// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__1wug1","buttons":"RemoveExpirationActionButtons_buttons__3fzew"};